import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm } from 'redux-form';
import Answer from '../../../components/answer';
import { answersToInitialValues } from '../../../utilities/formInstances';
import { getInstanceQuestions, getLatestPendingClassification, getJobQuestions, getClassificationScore } from '../../../reducers/formInstances';
import { FormattedMessage } from 'react-intl';
import messages from '../../../text/messages';
import { getContractor } from '../../../reducers/approvals';
import { getClients } from '../../../reducers/clients';
import Tooltip from 'rc-tooltip';
import { dateToFloatingString } from '../../../utilities/dateTime';
import { preClassificationQuestions } from '../assets/preClassificationQuestions';
import { jobStatus } from '../../../utilities/jobStatus';

class ClassificationsTab extends React.Component {
    constructor(props) {
        super(props);

        this.renderClientClassification = this.renderClientClassification.bind(this);
        this.renderWorkerPreClassification = this.renderWorkerPreClassification.bind(this);
        this.renderWorkerClassification = this.renderWorkerClassification.bind(this);
        this.renderClassificationScoreDetails = this.renderClassificationScoreDetails.bind(this);
        this.renderWorkerDontQualify = this.renderWorkerDontQualify.bind(this);
    }

    componentDidMount() {
        const {
            role,
            job,
            getInstanceQuestions,
            getLatestPendingClassification,
            getJobQuestions,
            getContractor,
            getClients,
            getClassificationScore
        } = this.props;

        getLatestPendingClassification(job.id, c => {
            getInstanceQuestions(c.id, undefined, undefined, `worker-classification-${job.id}`);
            getClassificationScore(c.id);
        });
        getJobQuestions(job.id, undefined, undefined, `client-classification-${job.id}`);
        getContractor({ type: 'contractor', id: job.contractor.id });
        getClients(role.id);
    }

    renderClientClassification() {
        const { clientQuestions, job, client } = this.props;
        const { classify_client_answers } = job;

        if (!clientQuestions || !classify_client_answers) {
            return null;
        }

        const { answers } = classify_client_answers;
        const questionAnswers = answers.map(answer => ({ title: answer.question_id, answer_type: 'y/n', answer }));
        let realQuestions = clientQuestions.map(q => {
            let questionAnswer = questionAnswers.find(a => a.answer.question_id === q.id);
            return { ...q, answer: questionAnswer ? questionAnswer.answer : undefined };
        });

        return (
            <React.Fragment>
                <FormattedMessage {...messages.clientClassification} tagName={'h4'} />
                <div className="col-xs-12">
                    {realQuestions.map((question, i) => (
                        <Answer key={i} definition={question} client_name={client ? client.name : 'the client'} formName={'approval-classification-form'} />
                    ))}
                </div>
                <div className="col-xs-12 section" />
            </React.Fragment>
        );
    }

    renderWorkerDontQualify() {
        const { job } = this.props;
        if (jobStatus(job) !== 'dont-qualify-ic') return null;

        const { progress } = job || {};
        const { help } = progress || {};
        const { reason, comment } = help || {};

        return (
            <React.Fragment>
                <FormattedMessage {...messages.choseDontQualify} tagName={'h4'} />
                <div className="row">
                    <div className="col-xs-12">Reason: {reason}</div>
                </div>
                <div className="row">
                    <div className="col-xs-12">Comment: {comment}</div>
                </div>
                <div className="col-xs-12 section" />
            </React.Fragment>
        );
    }

    renderWorkerPreClassification() {
        const { contractor, client } = this.props;
        if (!contractor || !contractor.preclassify_answers || !client) {
            return null;
        }

        const questions = preClassificationQuestions(client.name);

        const questionAnswers = contractor.preclassify_answers.answers.map(answer => ({ title: answer.question_id, answer_type: 'y/n', answer }));
        let realQuestions = questions.map(q => {
            let questionAnswer = questionAnswers.find(a => a.answer.question_id === q.id);
            return { ...q, answer: questionAnswer ? questionAnswer.answer : undefined };
        });

        return (
            <React.Fragment>
                <FormattedMessage {...messages.workerPreClassification} tagName={'h4'} />
                <div className="col-xs-12">
                    {realQuestions.map((question, i) => <Answer key={i} definition={question} formName={'approval-classification-form'} />)}
                </div>
                <div className="col-xs-12 section" />
            </React.Fragment>
        );
    }

    renderWorkerClassification() {
        const { workerQuestions, classificationScore } = this.props;
        if (!workerQuestions) {
            return null;
        }

        const confidence = classificationScore && Math.floor(classificationScore.confidence_percent + 0.5);
        const risk = classificationScore && Math.floor(classificationScore.risk_percent + 0.5);
        const riskLabel = risk === undefined || risk === null ? '??' : risk;

        const confidenceColor = confidence >= 90 ? 'green' : confidence >= 70 ? 'yellow' : 'red';
        const riskColor = risk >= 40 || confidence < 50 ? 'red' : risk > 25 ? 'yellow' : 'green';

        return (
            <React.Fragment>
                <FormattedMessage {...messages.classifyResult} tagName={'h4'} />
                {classificationScore && (
                    <div className="row">
                        <div className="col-xs-12">
                            <span className={`approval-chip-${riskColor}`}>
                                <span className="approval-chip-label">
                                    <FormattedMessage {...messages.risk} />
                                </span>
                                <span>{riskLabel}%</span>
                            </span>
                            <span className={`approval-chip-${confidenceColor}`}>
                                <span className="approval-chip-label">
                                    <FormattedMessage {...messages.answered} />
                                </span>
                                <span>{confidence}%</span>
                            </span>
                            <Tooltip trigger={'hover'} overlay={this.renderClassificationScoreDetails()}>
                                <span className="approval-chip">...</span>
                            </Tooltip>
                        </div>
                    </div>
                )}
                <div className="col-xs-12">
                    {workerQuestions.map((question, i) => <Answer key={i} definition={question} formName={'approval-classification-form'} />)}
                </div>
                <div className="col-xs-12 section" />
            </React.Fragment>
        );
    }
    renderClassificationScoreDetails() {
        const { classificationScore } = this.props;
        if (!classificationScore) {
            return null;
        }

        const { all, answered, confidence_percent, risk_percent, potential, review } = classificationScore;
        let renderQuestionsStatistics = (questions, title) => {
            const { num_questions, score_max, score_min } = questions;
            return (
                questions && (
                    <div className="group">
                        <FormattedMessage {...title} tagName={'strong'} />
                        {num_questions !== undefined && <FormattedMessage {...messages.numberOfQuestions} values={{ number: num_questions }} tagName={'div'} />}
                        {score_max !== undefined && <FormattedMessage {...messages.maxScore} values={{ number: score_max }} tagName={'div'} />}
                        {score_min !== undefined && <FormattedMessage {...messages.minScore} values={{ number: score_min }} tagName={'div'} />}
                    </div>
                )
            );
        };

        let renderReview = review => {
            const { review_date, review_note, reviewer, score_adjust, status } = review;
            return (
                <div>
                    <FormattedMessage {...messages.review} tagName={'strong'} />
                    {review_date && <FormattedMessage {...messages.reviewDate} values={{ value: dateToFloatingString(review_date) }} tagName={'div'} />}
                    {review_note && <FormattedMessage {...messages.reviewNote} values={{ value: review_note }} tagName={'div'} />}
                    {reviewer && <FormattedMessage {...messages.reviewer} values={{ value: reviewer }} tagName={'div'} />}
                    {score_adjust !== undefined && <FormattedMessage {...messages.scoreAdjust} values={{ value: score_adjust }} tagName={'div'} />}
                    {status && <FormattedMessage {...messages.reviewStatus} values={{ value: status }} tagName={'div'} />}
                </div>
            );
        };

        return (
            <div>
                <div className="group">
                    <div>
                        <FormattedMessage {...messages.risk} />
                        {`: ${risk_percent}`}
                    </div>
                    <div>
                        <FormattedMessage {...messages.confidence} />
                        {`: ${confidence_percent}`}
                    </div>
                </div>
                {renderQuestionsStatistics(all, messages.total)}
                {renderQuestionsStatistics(answered, messages.answered)}
                {renderQuestionsStatistics(potential, messages.potential)}
                {renderReview(review)}
            </div>
        );
    }

    render() {
        const { handleSubmit } = this.props;

        return (
            <form onSubmit={handleSubmit(() => null)}>
                {this.renderWorkerDontQualify()}
                {this.renderClientClassification()}
                {this.renderWorkerPreClassification()}
                {this.renderWorkerClassification()}
            </form>
        );
    }
}

ClassificationsTab = reduxForm({
    form: 'approval-classification-form',
    destroyOnUnmount: false,
    keepDirtyOnReinitialize: true,
    enableReinitialize: true,
    forceUnregisterOnUnmount: false
})(ClassificationsTab);

const mapStateToProps = (state, props) => {
    const { job } = props;

    let clients = state.clients.list;

    let workerQuestions = job && job.id ? state.formInstances[`worker-classification-${job.id}`] : undefined;
    let answers = workerQuestions ? workerQuestions.map(q => q.answer).filter(a => a !== undefined) : [];
    let questionAnswers = answers ? answersToInitialValues(answers) : {};
    let classification = state.formInstances.classification;
    let scores = state.formInstances.scores;
    let workerClassificationScore = classification && scores ? scores[classification.id] : undefined;

    return {
        role: state.identity.role,
        client: clients ? clients.find(c => c.id === props.job.client_id) : undefined,
        contractor: state.approvals.contractor,
        workerQuestions: job && job.id ? state.formInstances[`worker-classification-${job.id}`] : undefined,
        clientQuestions: job && job.id ? state.formInstances[`client-classification-${job.id}`] : undefined,
        classification,
        classificationScore: workerClassificationScore,
        admin: state.onboarding.admin,
        initialValues: { ...questionAnswers }
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getInstanceQuestions,
            getLatestPendingClassification,
            getClassificationScore,
            getJobQuestions,
            getContractor,
            getClients
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ClassificationsTab);



// WEBPACK FOOTER //
// ./src/pages/approval/tabs/classifications.jsx